import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LaborState {
  id: string;
  name: string;
  isActive: boolean;
  props: {
    [key: string]: any;
  };
}

const initialState: LaborState = {
  id: '',
  name: '',
  isActive: false,
  props: { isModalVisible: false, refresh: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const laborSlice = createSlice({
  name: 'labor',
  initialState,
  reducers: {
    setLabor: (state, action: PayloadAction<Partial<LaborState>>) => {
      return { ...state, ...action.payload };
    },

    resetLabor: (_state, action: PayloadAction<Partial<LaborState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateField: (state: LaborState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
  },
});

export const { setLabor, resetLabor, updateField, updateProps } = laborSlice.actions;

export default laborSlice.reducer;
